import type { EndorsementComponentData } from "@tm/api-utils";
import { LandingHeaderMobile, ReactPortalComp } from "@tm/static";
import React from "react";

import { InfoModalContent } from "../../OrderDetailV2/components/InfoModalContent";
import { TextButton } from "../../OrderDetailV2/components/TextButton";
import {
  ResultModalWrapper,
  ResultSheet,
  ResultSheetContent,
} from "./CancelPolicyResultModal.style";

export interface CancelPolicyResultModalProps {
  visible: boolean;
  viewType: "success" | "error";
  data: EndorsementComponentData | null;
  title?: string;
  onClose: () => void;
}

const DEFAULT_CTA_LABEL = "View your booking";

export const CancelPolicyResultModal: React.FC<
  CancelPolicyResultModalProps
> = ({ visible, viewType, data, title = "", onClose }) => {
  if (!visible) return null;

  const ctaLabel = data?.cta?.label || DEFAULT_CTA_LABEL;

  return (
    <ReactPortalComp>
      <ResultSheet>
        <LandingHeaderMobile
          displayWhiteHeader
          headerTitle={title}
          handleBackBtn={onClose}
        />
        <ResultSheetContent>
          <ResultModalWrapper>
            <InfoModalContent
              viewType={viewType}
              data={data}
              renderAction={() => (
                <TextButton
                  btnTxt={ctaLabel}
                  onClick={onClose}
                  showDefaultRightIcon={false}
                />
              )}
            />
          </ResultModalWrapper>
        </ResultSheetContent>
      </ResultSheet>
    </ReactPortalComp>
  );
};
